'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('businessPlanningModule')

    .factory('businessPlanningService', ['$http', 'env', function ($http, env) {

        var baseUrl = environment.apiUrl + '/Pilot/api/BusinessPlanning';
        var service = {};

        function returnData(response) {
            return response.data;
        }

        // Corporate Objective
        service.getAvailableCorporateObjectives = function (initiativeId) {
            return $http
                .get(baseUrl + '/InitiativeCreation/' + initiativeId + '/CorporateObjective/Available')
                .then(returnData);
        };

        // Submit PSS Definition
        service.submitPSSDefinition = function (planInitiativeId) {
            return $http
                .post(baseUrl + '/InitiativeCreation/' + planInitiativeId + '/PSSDefinition')
                .then(returnData);
        };

        // Business Units
        service.getAvailableBusinessUnits = function () {
            return $http
                .get(baseUrl + '/BusinessUnit')
                .then(returnData);
        };

        // Initiative
        service.createOrUpdateInitiative = function (initiative) {
            var url = baseUrl + '/Initiative';

            if (_.isUndefined(initiative.PlanInitiativeID)) {
                return $http
                           .post(url, initiative)
                           .then(function (response) {
                               var initiative = response.data;
                               formatInitiativeDates(initiative);

                               return initiative;
                           });
            }

            url += ('/' + initiative.PlanInitiativeID);
            return $http
                    .put(url, initiative)
                    .then(function (response) {
                        var initiative = response.data;
                        formatInitiativeDates(initiative);

                        return initiative;
                    });
        };
        service.getPlanInitiative = function (planInitiativeId) {
            return $http
                .get(baseUrl + '/Initiative/' + planInitiativeId)
                .then(function (response) {
                    var initiative = response.data;
                    formatInitiativeDates(initiative);

                    return initiative;
                });
        };

        // Delete Initiatives
        service.deletePlanInitiative = function (planInitiativeId) {
            return $http
                .delete(baseUrl + '/Initiative/' + planInitiativeId)
                .then(returnData);
        };

        // Lock Initiatives
        service.lockInitiative = function (planInitiativeId) {
            return $http
                .post(baseUrl + '/Initiative/' + planInitiativeId + '/CreationStatus/Locked', {})
                .then(returnData);
        };

        // Unlock Initiatives
        service.unlockInitiative = function (planInitiativeId) {
            return $http
                .post(baseUrl + '/Initiative/' + planInitiativeId + '/CreationStatus/Unlocked', {})
                .then(returnData);
        };

        // Get Plan Initiative with Budget
        service.getPlanInitiativeWithBudget = function (planInitiative) {
            return $http
                .post(baseUrl + '/InitiativeBudget/' + planInitiative.PlanInitiativeID + '/Budget', planInitiative)
                .then(returnData);
        };

        // Get Plan Initiative with Estimated Budget
        service.getPlanInitiativeWithEstimatedBudget = function (planInitiative) {
            return $http
                .post(baseUrl + '/InitiativeBudget/' + planInitiative.PlanInitiativeID + '/EstimatedBudget', planInitiative)
                .then(returnData);
        };

        // Get Edit Tasks
		service.getEditTasks = function (ownerDelegateId) {
			return $http
				.get(baseUrl + '/InitiativeCreation/OwnerDelegate@' + ownerDelegateId + '/Task')
				.then(returnData);
		};

        // Plan Deliverable
        service.getInitiativeDeliverable = function (initiativeId, deliverableId) {
            return $http
                .get(baseUrl + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId)
                .then(returnData);
        };
        service.getFollowUpsByPlanDeliverableID = function (initiativeId, deliverableId) {
            var reqUrl = baseUrl + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/FollowUp';

            return $http
                    .get(reqUrl)
                    .then(returnData);
        };
        service.createOrUpdateDeliverable = function(initiativeId, deliverable) {
            return $http
                .post(baseUrl + '/Initiative/'+initiativeId+'/Deliverable',
                    {planDeliverable: deliverable})
                .then(returnData);
        };
        service.assessDeliverable = function(assessorId, initiativeId, deliverableId, assessment) {
            return $http
                .post(baseUrl + '/InitiativeUpdateStatus/Assessor@'+assessorId+'/Initiative/'+initiativeId+'/Deliverable/'+deliverableId, assessment)
                .then(returnData);
        };
        service.resetAssessment = function (assessorId, initiativeId, deliverableId, assessment) {
            return $http
                .post(baseUrl + '/InitiativeUpdateStatus/Assessor@'+assessorId+'/Initiative/'+initiativeId+'/Deliverable/'+deliverableId+'/Reset', assessment)
                .then(returnData);
        };
        service.deletePlanDeliverable = function (planInitiativeId, planDeliverableId) {
            return $http
                .delete(baseUrl + '/Initiative/' + planInitiativeId + '/Deliverable/' + planDeliverableId)
                .then(returnData);
        };

        // Lookups
        service.getPlanLookups = function () {
            return $http
                .get(baseUrl + '/Initiative/Lookup', { cache: true })
                .then(returnData);
        };

        // Get LookupAttributes
        service.getLookupAttributeValues = function () {
            var reqUrl = environment.apiUrl + '/Pilot/api/LookupAttribute/Value/For/PlanInitiative';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // InitiativeUpdateStatus

        // Select All Initiatives
        service.getAllFoundPlanInitiativeIDs = function (searchFilters) {
            return $http
                .get(environment.apiUrl + '/Pilot/api/PlanInitiative/GetAllFoundPlanInitiativesIDs', {params: searchFilters})
                .then(returnData);
        };

        // Create assessments
        service.createAssessmentsForPlanInitiatives = function (initiativeIds) {
            return $http
                .post(baseUrl + '/Initiative/Assessment', initiativeIds)
                .then(returnData);
        };

        // GetAssessmentTasks
        service.getAssessmentTasks = function (assessorId) {
            return $http
                .get(baseUrl + '/InitiativeUpdateStatus/Assessor@'+assessorId+'/Task')
                .then(returnData);
        };

        // Get Owners And Status
        service.getOwnersAndStatus = function (opts) {
            return $http
                .get(baseUrl + '/InitiativeUpdateStatus/OwnerAndStatus', opts)
                .then(returnData);
        };

        // Change Creation Status of multiple Initiatives
        service.changeCreationStatus = function (newStatus, initiativeIds) {
            return $http
                .post(baseUrl + '/Initiative/CreationStatus/' + newStatus, initiativeIds)
                .then(returnData);
        };

        // Send Reminder To Owner
        service.sendReminderToOwner = function (owner) {

            var isDebug = env.isDev || undefined;

            return $http
                .post(baseUrl + '/InitiativeUpdateStatus/OwnerAndStatus/Owner@' +
                      owner.ItemPersonID + '/SendReminder', {
                          isDebug: isDebug,
                          owner: owner
                      })
                .then(returnData);
        };

        // Get all available mitigated risks
        service.getAllMitigatedRisks = function (planInitiativeId) {
            return $http
                .get(baseUrl + '/InitiativeCreation/' + planInitiativeId + '/Risk/Available')
                .then(returnData);
        };

        // Get available metrics for initiative
        service.getAvailableMetricsForInitiative = function (planInitiativeId) {
            return $http
                .get(baseUrl + '/InitiativeCreation/' + planInitiativeId + '/Metric/Available')
                .then(returnData);
        };

        // Get all available Fiscal Years
        service.getAvailableFiscalYears = function (planInitiativeId) {
            return $http
                .get(baseUrl + '/InitiativeCreation/' + planInitiativeId + '/FiscalYear/Available')
                .then(returnData);
        };

        function formatInitiativeDates(initiative) {
            if (initiative.TargetDate) initiative.TargetDate = moment(initiative.TargetDate).format();
            if (initiative.CompletionDate) initiative.CompletionDate = moment(initiative.CompletionDate).format();
        }

        return service;

    }]);
